<template>
  <div class="payment-card">
    <div class="payment-card-box">
      <form @submit.prevent="postPayment">
        <div class="payment-card-banner">
          <div class="banner-logo">
            <div class="logo-wrap">
              <img src="@/assets/images/nic-asia-bank.png" alt="" v-if="!customerData.merchantDetail.merchantLogo" />
              <img v-else :src="customerData.merchantDetail.merchantLogo" />
            </div>
          </div>
          <div class="banner-text">
            <h1 class="payment-heading">
              {{ customerData.merchantDetail.companyName }}
            </h1>
            <span class="sub-title"> {{ customerData.merchantDetail.contactNumber }} </span>
            <h2 class="payment-amount">
              {{ formatCurrency(customerData) }}
            </h2>
          </div>
        </div>
        <div class="payment-card-body">
          <payment-success :paymentDetail="paymentDetail" v-if="isRequested" />
          <template v-else>
            <div class="payment-user-info">
              <div class="user-info-box">
                <div class="edit-info">
                  <span class="mdi mdi-file-edit-outline"> </span>
                </div>
                <div class="info-box">
                  <span>{{ customerData.customerPaymentDetail.mobileNumber.includes("+") ? "" : "+977" }}
                    {{
        customerData.customerPaymentDetail.mobileNumber
      }}</span>
                  <span>{{ customerData.customerPaymentDetail.email }}</span>
                </div>
              </div>
            </div>
            <h6 class="body-title">PREFERRED PAYMENT METHODS</h6>
            <v-expansion-panels class="payment-panel">
              <v-expansion-panel v-for="(item, i) in allowedPaymentModes()" :key="i">
                <v-expansion-panel-header @click="loadModeForm(item)">
                  <div class="panel-header">
                    <div class="header-icon">
                      <span v-if="item.mode === 'CYBERSOURCE'" class="mdi mdi-credit-card-multiple-outline"></span>
                      <span v-else-if="item.mode === 'MOBANK'" class="mdi mdi-cellphone-arrow-down"></span>
                      <span v-else-if="item.mode === 'CONNECT_IPS'" class="mdi mdi-wallet-outline"></span>
                      <span v-else class="mdi mdi-bank-transfer"></span>
                    </div>
                    <div class="header-title">
                      <h5 class="header-main-title">
                        {{ item.paymentModeName }}
                      </h5>
                      <v-subheader v-if="item.mode === 'CYBERSOURCE'">Visa & MasterCard </v-subheader>
                      <v-subheader v-if="item.mode === 'MOBANK'">FonePay & More</v-subheader>
                      <v-subheader v-if="item.mode === 'CONNECT_IPS'">{{
        item.paymentModeName
      }}</v-subheader>
                    </div>
                    <div class="select-option">
                      <v-checkbox :value="item.mode" v-model="paymentMedium"></v-checkbox>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="form-loader-wrap" v-if="formLoader">
                    <p>Getting Required Fields</p>
                    <v-progress-linear color="primary accent-4" indeterminate rounded height="6"></v-progress-linear>
                  </div>
                  <template v-if="paymentModeData.length > 0 && !formLoader">
                    <div class="payment-form-wrap">
                      <div class="payment-form-group" v-for="(item, index) in paymentModeData" :key="index">
                        <v-text-field :label="item.columnName" v-model="item.value" outlined required dense
                          class="custom-filled"></v-text-field>
                      </div>
                    </div>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </div>
        <transition name="fade" v-if="paymentMedium !== null && !isRequested">
          <div class="payment-card-footer">
            <v-btn class="ma-2" color="primary" width="100%" height="55px" :loading="paymentLoading"
              :disabled="paymentLoading || formLoader" type="submit">
              {{ `Pay (${formatCurrency(customerData)})` }}
            </v-btn>
          </div>
        </transition>
      </form>
    </div>
    <!-- <Redirect :formInputs="formInputs" /> -->
    <form ngNoForm ref="CYBERSOURCE" v-if="isResponseReceived && paymentMedium === 'CYBERSOURCE'"
      id="payment_confirmation" :action="cyberSourceLink" method="post">
      <div v-for="(value, name) in formInputs" :key="name">
        <input type="hidden" :id="name" :name="name" :value="value" />
      </div>
    </form>


    <form ngNoForm ref="CONNECT_IPS" v-if="isResponseReceived && paymentMedium === 'CONNECT_IPS'"
      :action="connectIpsLink" method="post">
      <div v-for="(value, name) in formInputs" :key="name">
        <input type="hidden" :id="name" :name="name" :value="value" />
      </div>
    </form>

    <form method="post" v-if="isResponseReceived && paymentMedium === 'IBANKING'" :action="formURL" ref="IBANKING">
      <input type="hidden" :id="name" :name="name" :value="value" v-for="(value, name) in formInputs" :key="name" />

      <!-- <FORM METHOD="GET" ACTION="https://bokclick.bok.com.np/client/epay.xhtml"> -->
      <!-- <input type="hidden" name="PID" value="000000000025">
            <input type="hidden" name="MD" value="P">
            <input type="hidden" name="RU" value="google.com/">
            <input type="hidden" name="PRN" value="000000000025">
            <input type="hidden" name="AMT" value="1002.0">
            <input type="hidden" name="ITC" value="1">
            <input type="hidden" name="UniqueId" value="22242877674">
	    <input type="hidden" name="PAID" value="Y">
           <input type="hidden" name="BID" value="C1244F4561213">
            <input type="submit" name="commit" value="Pay Now" class="button"> -->
    </form>
    <form method="post" v-if="isResponseReceived && paymentMedium === 'FONEPAY'" :action="fonepayUrl" ref="FONEPAY">
      <!-- <input
        type="hidden"
        :id="name"
        :name="name"
        :value="value"
        v-for="(value, name) in formInputs"
        :key="name"
      /> -->
    </form>
  </div>
</template>
<script>
import Promise from "../../../lib/mixins/ExtendedPromises";
import Payment from "../../../repositories/payment";
import PaymentSuccess from "./PaymentSuccess.vue";
import Redirect from "./Redirect";
import { formatCurrency } from '../../../lib/currency'

export default {
  name: "PaymentCard",
  mixins: [Promise],
  components: {
    PaymentSuccess,
    Redirect
  },
  props: {
    customerData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      paymentLoading: false,
      paymentDetail: {},
      isRequested: false,
      paymentMedium: null,
      paramId: "",
      paymentMappedData: {
        paymentHashMap: null
      },
      isResponseReceived: false,
      formInputs: {},
      iTouchUrl: "",
      fonepayUrl: "",
      paymentModeData: [],
      cyberSourceLink: '',
      connectIpsLink: '',
      formLoader: false
    };
  },
  mounted() {
    this.getUrlParam();
  },
  methods: {
    formatCurrency,
    loadModeForm(item) {
      this.formLoader = true;
      if (item.mode === this.paymentMedium) {
        this.paymentMedium = null;

      } else {
        this.paymentMedium = item.mode;

      }
      if (item.mode === 'NEPAL_PAYMENT') {
        this.$router.push({
          path: `/nepalpay/${this.paramId}`
        });
        this.formLoader = false;
        return
      }

      const operation = this.response(
        Payment.getCustomerFormDetailByModeValue(this.paramId, item.mode)
      );
      operation
        .then(data => {
          if (operation.isFulfilled()) {
            this.paymentModeData = data.data;
            this.paymentModeData = this.paymentModeData.map(item => {
              return { ...item, value: "" };
            });
            this.formLoader = false;
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
          this.formLoader = false;
        });
    },
    getUrlParam() {
      this.paramId = this.$route.params.id;
    },
    postPayment() {
      this.paymentLoading = true;
      if (this.paymentModeData.length > 0) {
        this.paymentMappedData.paymentHashMap = {};
        this.paymentModeData.forEach(item => {
          this.paymentMappedData.paymentHashMap[item.jsonKey] = item.value;
        });
      } else {
        this.paymentMappedData = {
          paymentHashMap: null
        };
      }

      const operation = this.response(
        Payment.postPayment(
          this.paramId,
          this.paymentMedium,
          this.paymentMappedData
        )
      );
      operation
        .then(data => {
          if (operation.isFulfilled()) {

            this.isResponseReceived = true;
            this.formInputs = { ...data.data.paymentHashMap };
            if (this.paymentMedium === "IBANKING") {
              this.formURL = this.formInputs.URL;
              this.submitPaymentForm(this.paymentMedium);
            }

            if (this.paymentMedium === "CYBERSOURCE") {
              this.cyberSourceLink = data.data.redirectionUrl;
              this.submitPaymentForm(this.paymentMedium);
            }

            if (this.paymentMedium === "CONNECT_IPS") {
              this.connectIpsLink = data.data.redirectionUrl;
              this.submitPaymentForm(this.paymentMedium);
            }

            if (this.paymentMedium === "FONEPAY") {
              this.fonepayUrl = data.data.redirectionUrl;
              this.submitPaymentForm(this.paymentMedium);
            }
            if (this.paymentMedium === "MOBANK" || this.paymentMedium === "IMEPAY" || this.paymentMedium === "KHALTI") {
              window.open(this.formInputs.URL, "_self");
            }
          }
        })
        .catch(err => {
          this.$toasted.show(err.data.message, {
            type: "error"
          });
        });
    },
    submitPaymentForm(formID) {
      setTimeout(() => {
        this.$refs[formID].submit();
        this.paymentLoading = false;
      }, 1500);
    },
    allowedPaymentModes() {
      const currency = this.customerData.currency;
      if (currency) {
        const isNpr = currency.code === "NPR"
        const allPaymentModes = this.customerData.merchantPaymentModes
        if (isNpr) {
          return allPaymentModes;
        } else {
          return allPaymentModes.filter((pMode) => pMode.mode === "CYBERSOURCE")
        }
      } else {
        return this.customerData.merchantPaymentModes
      }
    }
  }
};
</script>
